import React, { useContext, useState, useEffect } from "react";
import { Container, Card, Row, Col, Modal, Button, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import backgroundImage from "../../../assets/images/background.png";
import rideImg from "../../../assets/images/ride_car.png";
import outstationImg from "../../../assets/images/city-to-city.png";
import { ArrowRight, Star, Car, Users, Calendar } from "lucide-react";
import "../../../assets/css/Customer/CustomerDashboard/CustomerDashboard.css";
import CustomerMasterLayout from "../../../layouts/Customer/CustomerMasterLayout";
import SingleOfferCard from "../../../components/Customer/Offers/SingleOfferCard";
import AppContext from "../../../context/AppContext";
import axios from "axios";

const CustomerDashboard = () => {
  const navigate = useNavigate();
  const { baseUrl, authToken, setSelectedRideType, setSelectedOffer } = useContext(AppContext);

  const [offers, setOffers] = useState([]);
  const [loadingOffers, setLoadingOffers] = useState(true);

  const [showOfferModal, setShowOfferModal] = useState(false);
  const [selectedOfferForModal, setSelectedOfferForModal] = useState(null);

  const getCustomerDashboardStats = () => {
    axios
      .get(`${baseUrl}/customer/dashboard`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getActiveOffers = () => {
    setLoadingOffers(true);
    axios
      .get(`${baseUrl}/customer/offer/viewOffer`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        setOffers(response.data.offers || []);
      })
      .catch((error) => {
        console.error("Offers fetch error:", error);
      })
      .finally(() => setLoadingOffers(false));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getCustomerDashboardStats();
    getActiveOffers();
  }, []);

  const handleOfferClick = (offer) => {
    setSelectedOfferForModal(offer);
    setShowOfferModal(true);
  };

  const handleBookNow = () => {
    setSelectedOffer(selectedOfferForModal);
    setShowOfferModal(false);
    navigate("/customer-instant-ride");
  };

  const handleScheduleForLater = () => {
    setSelectedOffer(selectedOfferForModal);
    setShowOfferModal(false);
    navigate("/customer-ride-selection");
  };

  return (
    <CustomerMasterLayout screenName={"TrustiDrive"}>
      <div className="CustomerDashboard-main-container">
        <Container fluid className="CustomerDashboard-content px-3">
          {/* Banner Card */}
          <Card
            className="CustomerDashboard-ready-card"
            style={{ backgroundImage: `url(${backgroundImage})` }}
          >
            <div className="CustomerDashboard-ready-overlay"></div>
            <Card.Body className="CustomerDashboard-ready-body">
              <h2 className="CustomerDashboard-ready-title">Ready?</h2>
              <p className="CustomerDashboard-ready-subtitle">
                Then let's roll now.
              </p>
            </Card.Body>
          </Card>

          {/* Top Categories */}
          <div className="CustomerDashboard-categories">
            <h2 className="CustomerDashboard-categories-title">
              Top Categories
            </h2>
            <Row className="g-2">
              <Col xs={6}>
                <Card
                  className="CustomerDashboard-category-card"
                  onClick={() => {
                    setSelectedOffer(null); // normal ride — offer reset
                    setSelectedRideType("ir");
                    navigate("/customer-instant-ride");
                  }}
                >
                  <Card.Body className="p-3">
                    <h5 className="CustomerDashboard-category-title">
                      Ride instant
                    </h5>
                    <div className="d-flex align-items-center justify-content-between mt-4">
                      <ArrowRight size={18} color="#adb5bd" />
                      <img
                        src={rideImg}
                        alt="Ride"
                        className="CustomerDashboard-category-img"
                      />
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              <Col xs={6}>
                <Card
                  className="CustomerDashboard-category-card"
                  onClick={() => {
                    setSelectedOffer(null); // normal ride — offer reset
                    setSelectedRideType("c2c");
                    navigate("/customer-ride-selection");
                  }}
                >
                  <Card.Body className="p-3">
                    <h5 className="CustomerDashboard-category-title">
                      City to city
                    </h5>
                    <div className="d-flex align-items-center justify-content-between mt-4">
                      <ArrowRight size={18} color="#adb5bd" />
                      <img
                        src={outstationImg}
                        alt="City to City"
                        className="CustomerDashboard-category-img"
                      />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>

          {/* Today's Offer */}
          <div className="CustomerDashboard-offers">
            <h2 className="CustomerDashboard-offers-title">Today's Offer</h2>

            {loadingOffers && <p>Loading offers...</p>}

            {!loadingOffers && offers.length === 0 && (
              <p className="text-muted">No active offers right now.</p>
            )}

            {offers.map((offer) => (
              <div
                key={offer.id}
                onClick={() => handleOfferClick(offer)}
                className="CustomerDashboard-offer-item"
              >
                <SingleOfferCard offer={offer} />
              </div>
            ))}
          </div>
        </Container>
      </div>

      {/* ===== Offer Popup Modal ===== */}
      <Modal
        show={showOfferModal}
        onHide={() => setShowOfferModal(false)}
        centered
        className="OfferModal-wrapper"
      >
        {selectedOfferForModal && (
          <Modal.Body className="OfferModal-body">
            <div className="OfferModal-discount-circle">
              <span className="OfferModal-discount-value">
                {selectedOfferForModal.discount_percent}%
              </span>
              <span className="OfferModal-discount-label">OFF</span>
            </div>

            <h4 className="OfferModal-title">Special Offer 🎉</h4>
            <p className="OfferModal-description">
              {selectedOfferForModal.description}
            </p>

            <div className="OfferModal-info-row">
              <div className="OfferModal-info-item">
                <Users size={16} color="#1B9B82" />
                <span>{selectedOfferForModal.max_users} users max</span>
              </div>
              <div className="OfferModal-info-item">
                <Calendar size={16} color="#1B9B82" />
                <span>
                  Valid till{" "}
                  {selectedOfferForModal.valid_till
                    ? new Date(selectedOfferForModal.valid_till).toLocaleDateString()
                    : "N/A"}
                </span>
              </div>
            </div>

            {selectedOfferForModal.driver && (
              <div className="OfferModal-driver-row">
                <div className="flex-grow-1">
                  <p className="OfferModal-driver-name">
                    {selectedOfferForModal.driver.drivername || "Driver"}
                  </p>
                  <div className="d-flex align-items-center gap-1">
                    <Star size={14} fill="#FFB800" color="#FFB800" />
                    <span className="OfferModal-driver-rating">
                      {selectedOfferForModal.driver.rating || "4.5"}
                    </span>
                  </div>
                </div>
              </div>
            )}

            <div className="OfferModal-buttons">
              <Button
                className="OfferModal-btn-schedule"
                onClick={handleScheduleForLater}
              >
                Schedule for Later
              </Button>
              <Button
                className="OfferModal-btn-booknow"
                onClick={handleBookNow}
              >
                Book Now
              </Button>
            </div>
          </Modal.Body>
        )}
      </Modal>
    </CustomerMasterLayout>
  );
};

export default CustomerDashboard;